import { canUseDOM, cookie } from '@pmi/pmi-iqos-shared-react'

const noop = () => {}

export class DCXAnalyticsManager {
  constructor(dataLayer) {
    this.dataLayer = dataLayer || []
  }

  threeDSResult = success => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEvent',
      eventCategory: 'Checkout',
      eventLabel: `3D Secure - Payment ${success ? 'Success' : 'Failure'}`,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }
}

export default new DCXAnalyticsManager(canUseDOM ? window.dataLayer : null) // set by google tag manager
